
/* eslint-disable */
import Vue from 'vue'
import axios from 'axios'
import YunJi from '@/assets/js/YunJi'

const AJAX = axios.create({
  baseURL: `//${globalConfig.ysappItemBasePath}`,
  withCredentials: true
})

function loadMarkDetialNew(param) {
  if (param && (param.appCont == 1 || param.appCont == 2)) {
    param.appVersion = YunJi.getAppIdForH5()
    // param.appVersion = '20220124'
  }
  return new Promise((resolve, reject) => {
    AJAX('/yunjiysapp/app/queryItemListMarks.json', {
      params: param
    }).then((res) => {
      if (res.data.errorCode == 0 && res.data.data) {
        resolve([...res.data.data])
      }
    }).catch((res) => {
      resolve([])
    })

    // $.ajax({
    //   url:"//" + globalConfig.ysappItemBasePath + "/yunjiysapp/app/queryItemListPolymerizationMark.json",
    //   type:"GET",
    //   dataType: "json",
    //   data:param,
    //   success: (res) => {
    //     console.log(res)
    //     if(res.errorCode == 0 && res.data){
    //       resole([...res.data])
    //     }
    //   },
    //   error: ()=> {
    //     console.log('11111111111111')
    //     resole([])
    //   }
    // })
  })
}


/**
 * 新打标 
 * @param {*} itemList  
 * @param {*} markList 
 */
function setMarkeMsgArrayByItemMarkeNew(itemList, markList, templateId) {
  itemList.forEach((item) => {
    const markObj = markList.find(mark => mark.itemId == item.itemId)
    if (markObj) {
      const imageMark = markObj.imageMark
      let markList = (markObj.itemLabelMarkingResponses || []).map((m) => {
        const img = m.markingImg || m.img
        const o = {
          colour:m.colour,
          colorType: m.type == 4 ? 3 : 1, // 3紫色 1红色,
          name: m.text,
          type: m.type,
          newFlag: 1, // 区分旧版标
          img
        }
        if (m.type == 6 && img) {
          Vue.set(item, 'atmosphereMark', m.img)
        }
        return o
      })
      if (templateId == 5) { // 购物车不需要业务标
        markList = markList.filter(i => i.type != 1)
      }
      Vue.set(item, 'imageMark', imageMark)
      Vue.set(item, 'markArray', markList)
    }
  })
}


/**
 * 商品信息列表itemList 更新item打标标识
 * businessMarkType 打标类型 1-营销活动标、2-奖励标 
 * 默认没有奖励标
 * hasRewardMarke true 有奖励标
 * templateId： 打标模板类型 1-大图列表标签 2-大图专题列表标签 3-一列列表标签 4-一列专题列表标签 5-购物车列表标签 6-两列列表标签 7-三列滑动式列表标签
 * @export
 * @param {*} [itemList=[]]
 * @returns
 */
export function setMarkeLabelByItemsListNew(itemList = [], hasRewardMarke = false, appCont = 0, templateId) {
  if (itemList.length <= 0) return
  const itemIds = itemList.reduce((str, obj, index) => str += `${obj.itemId}${index < itemList.length - 1 ? ',' : ''}`, '')
  const businessMarkType = hasRewardMarke ? '1,2' : '1'// 营销活动标
  // 请求参数
  const markeParams = {
    appCont: appCont,
    strVersion: 1,
    itemIds: itemIds,
    businessMarkType: businessMarkType,
    templateId: templateId,
    ticket: YunJi.getUrlParams('ticket') || ''
  }
  loadMarkDetialNew(markeParams).then((res) => {
    setMarkeMsgArrayByItemMarkeNew(itemList, res, templateId)
    return itemList
  }).catch(err => itemList)
  return itemList
}
